import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function RewardIncome() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [RankId, setRankId] = useState("2");
  const [RankList, setRankList] = useState([]);

  const [TotalAmount, setTotalAmount] = useState(0);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/GetIncomeReportsAdmin",
        {
          loginid: userId,
          uid: search,
          type: "AdminRewardMaster",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      responceRight = responceRight?.data?.data[0];

      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        if (RankId === "2" || String(item?.paid) === String(RankId)) {
          arrayLeft.push({
            sr: index + 1,
            uid: item.uid,
            Fname: item.Fname,
            lvl: item?.lvl,
            ReqTeam: `${item.reqteam}`,
            Team: `${item.team}`,
            Reward: `${item.reward}`,
            remark: `${item.ST}`,
            date: ` ${item.dd}`,
            Pdate: item?.paid === 0 ? "" : `${item.pd}`,
            Achived:
              item?.paid === 0 ? (
                <>
                  <button
                    className="btn btn-danger"
                    onClick={() => Status_active(item?.uid, item?.id)}
                  >
                    {" "}
                    Pay Now
                  </button>
                </>
              ) : (
                <>
                  <button className="btn btn-primary">Reward Paid</button>
                </>
              ),
          });
        }
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, [RankId]);

  const Status_active = async (UId, RId) => {
    try {
      let confirm = window.confirm(
        "Are you sure, you want to Pay this Reward?",
      );
      if (confirm) {
        let responceRight = await API?.post(
          "/Updateuserrank",
          {
            loginid: userId,
            Userid: UId,
            Rankid: RId,
            type: 7,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          },
        );

        if ((responceRight.data.data = "Success")) {
          toast.success("Reward Paid Successfully ..");
          referral_API();
          // window.location.reload();
        } else {
          toast.error(responceRight.data.data);
        }
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Name", accessor: "Fname" },

      { Header: "Req. Team", accessor: "ReqTeam" },
      { Header: "Team", accessor: "Team" },
      { Header: "Reward", accessor: "Reward" },
      // { Header: "Req. Manager", accessor: "ReqManager" },
      // { Header: "Manager", accessor: "Manager" },
      // { Header: "Req. Sr. Manager", accessor: "ReqSrManager" },
      // { Header: "Sr. Manager", accessor: "SrManager" },
      { Header: "Status", accessor: "remark" },
      { Header: "Achieved Date", accessor: "date" },

      { Header: "Paid Status", accessor: "Achived" },
      { Header: "Paid Date", accessor: "Pdate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">User Reward</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        type="text"
                        id="txtuid"
                        ng-model="p.uid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                    </div>
                    <div class="col-md-3">
                      <select
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty"
                        onChange={(e) => {
                          setRankId(e.target.value);
                        }}
                      >
                        <option value="2" selected="selected">
                          All
                        </option>
                        <option value="1">Paid</option>
                        <option value="0">Unpaid</option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    {/*<h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4>*/}

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
